// extracted by mini-css-extract-plugin
module.exports = {"writeSubcategoryCard":"ListSubcategory_writeSubcategoryCard__1xXTP","ImageContainer":"ListSubcategory_ImageContainer__2f9JS"};